import React from 'react';
import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="container" style={{ maxWidth: 760, marginTop: 32, marginBottom: 48 }}>
      <h1>Terms &amp; conditions</h1>
      <p className="muted small">Last updated on first deployment. Please read before using PMP Revise.</p>
      <div className="divider" />

      <div className="stack">
        <div>
          <h3>1. What PMP Revise is</h3>
          <p className="muted small">
            PMP Revise is an independent study aid for candidates preparing for the PMI Project
            Management Professional (PMP)® certification exam. It is not affiliated with, endorsed
            by, or sponsored by the Project Management Institute (PMI). "PMP", "PMBOK", and related
            marks are trademarks of PMI.
          </p>
        </div>
        <div>
          <h3>2. Study aid, not a guarantee</h3>
          <p className="muted small">
            The assistant produces AI-generated content that can be incomplete or wrong. Always
            verify against the official PMI Exam Content Outline (ECO) and current PMBOK® Guide.
            Using this app does not guarantee any exam result.
          </p>
        </div>
        <div>
          <h3>3. Exam integrity</h3>
          <p className="muted small">
            You agree to use PMP Revise only for legitimate exam preparation. PMI does not release
            official past exam papers, and the use of leaked or "brain dump" exam content violates
            PMI's certification policies. Do not upload, request, or share such material, and do not
            attempt to use the assistant during a live exam. Accounts used to facilitate cheating may
            be suspended or revoked.
          </p>
        </div>
        <div>
          <h3>4. Copyrighted material</h3>
          <p className="muted small">
            Do not upload or paste copyrighted material (for example, verbatim PMBOK® Guide text or
            third-party question banks) unless you hold the rights to do so. The assistant will not
            reproduce copyrighted works verbatim and will paraphrase concepts instead.
          </p>
        </div>
        <div>
          <h3>5. Accounts and security</h3>
          <p className="muted small">
            You are responsible for keeping your credentials secure. Sign-in uses two-step email
            verification. We may suspend, lapse, or revoke access in line with our operating policy;
            a lapsed account has a recoverable window before any operator-reviewed removal.
          </p>
        </div>
        <div>
          <h3>6. Privacy and communications</h3>
          <p className="muted small">
            We send transactional emails (verification, sign-in codes, password resets). We do not
            send any outbound communication to lapsed or revoked accounts.
          </p>
        </div>
      </div>

      <div className="divider" />
      <Link to="/register" className="btn btn-primary">I understand — create my account</Link>
    </div>
  );
}
